export const getChatUrl = (baseUrl: string) => {
  const consultationUrl = `${baseUrl}/consultation`
  return {
    CREATE_NEW_CHAT: `${consultationUrl}`,
    GET_CONSULTATION_LIST: consultationUrl,
    GET_CONSULTATION_CHAT_MESSAGE_LIST: (consultation_id: number) => `${consultationUrl}/${consultation_id}/messages`,
    CONTINUE_CONSULTATION: (consultation_id: number) => `${consultationUrl}/${consultation_id}`,
    DELETE_CONSULTATION: (consultation_id: number) => `${consultationUrl}/${consultation_id}`,
    FINISH_CONSULTATION: (consultation_id: number) => `${consultationUrl}/${consultation_id}/finish`,
    EDIT_CONSULTATION_TITLE: (consultation_id: number) => `${consultationUrl}/${consultation_id}/title`,
    SWITCH_CHITCHAT: (consultation_id: number) => `${consultationUrl}/${consultation_id}/switch`,
    GET_CONSULTATION_DETAIL: (consultation_id: number) => `${consultationUrl}/${consultation_id}`,
    FEEDBACK_CONSULTATION: (consultation_id: number) => `${consultationUrl}/${consultation_id}/feedback`,
    GET_ACTIVE_CONSULTATION: () => `${consultationUrl}/active`,
    GET_RECOMMENDATION_RESPONSE: (consultation_id: number) => `${consultationUrl}/${consultation_id}/recommendation`,
    GET_TAKEOVER_NOTE_STATUS: (block_id: number) => `${consultationUrl}/${block_id}/takeover_note_status`,
    GET_CONVERSATION_REPORT_STATUS: (consultation_id: number) =>
      `${consultationUrl}/${consultation_id}/conversation-report`
  }
}
